<template>
    <div>
      <v-checkbox 
        :label="label"
        v-model="innerValue"
        variant="outlined"
        hide-details="auto"
        :value="1"
        :readonly="props.readOnly"
      />
    </div>
  </template>

  <script>
export default {
  name: "TimeComponent",

  props: {
    modelValue: {
      type: String,
      default: null
    },
    label: {
      type: String,
      default: ""
    },
    readOnly: {
      type: Boolean,
      default: false
    },
  },

  data() {
    return {
      innerValue: this.modelValue
    }
  },

  watch: {
    modelValue(val) {
      this.innerValue = val
    },
    innerValue(val) {
      this.$emit("update:modelValue", val)
    }
  }
}
</script>
